"use client";

import { useContext, useEffect } from "react";
import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { ResourceContext } from "@/contexts/resource-context";

export const LogView = ({
  medGroups,
  query,
}: {
  medGroups: MedGroupPreviewVM[];
  query?: string;
}) => {
  const usedVersions: string[] = [];
  const { logView } = useContext(ResourceContext);

  useEffect(() => {
    medGroups.forEach((group) => {
      if (group.featured && !usedVersions.includes(group.title)) {
        usedVersions.push(group.title);
        logEvent("search_med_view", logView, {
          resourceTitle: group.title,
          resourceURL: createPath("meds.group.show", {
            slug: group.slug,
            id: group.id,
          }),
          query: query ?? null,
          is_global_search: false,
        });
      }
    });
  }, [medGroups]);
  return <></>;
};
